var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5 18c0 3-5.5 7-7.5 7-1.014 0-2.927-1.029-4.567-2.434l1.419-1.418a12.4 12.4 0 0 0 2.068 1.413c.74.391 1.094.439 1.08.439s.34-.048 1.08-.44a12.4 12.4 0 0 0 2.128-1.461c.717-.607 1.332-1.26 1.752-1.872.442-.643.54-1.055.54-1.227v-5.5l2-2zm0-11v.672l-.515.514L22 8.2l-12 12-.015-.014-.973.973C8.117 20.12 7.5 19.004 7.5 18V7L15 5zm-13 1.536v9.336l9.686-9.686L15 7.069z"
  })));
};
export default SvgTeam;